import { CTRL_KEY } from "../../../lib/utils/consts";
import { pasteComponentToDesigner, copyComponentToClipBoard } from './copyAndPasteComponent';
import { readClipboard } from "../../../lib/utils/browser/clipboard";
import { startMouseMove } from "../../../lib/utils";
import { CompInspector } from "../../../lib/comps/CompInspector";
export default class DesignerKeyPressEventHandler {
  constructor(designer) {
    this.designer = designer;
  }
  keyPressHandler(ev) {
    var _ev$target;
    const {
      code
    } = ev;
    const CTRL = 0b001;
    const SHIFT = 0b010;
    const ALT = 0b100;
    const mod = (+ev[CTRL_KEY] && CTRL) | (+ev.shiftKey && SHIFT) | (+ev.altKey && ALT);
    if ((_ev$target = ev.target) !== null && _ev$target !== void 0 && _ev$target.matches('textarea, button, select, input')) return;
    // console.log('keyCode', keyCode);
    if (code === 'Delete' || code === 'Backspace') {
      // Delete 或者 Backspace
      this.designer.deleteActiveComp();
      ev.preventDefault();
      return;
    }
    if (mod === CTRL && code === 'ArrowLeft') {
      if (this.designer.compPath) this.designer.selectParent();else this.designer.exitScope();
      ev.preventDefault();
      return;
    }
    if (mod === CTRL && code === 'ArrowRight') {
      this.designer.selectFirstChild();
      ev.preventDefault();
      return;
    }
    if (mod === CTRL && code === 'ArrowUp') {
      this.designer.selectAdjacentComp(-1);
      ev.preventDefault();
      return;
    }
    if (mod === CTRL && code === 'ArrowDown') {
      this.designer.selectAdjacentComp(1);
      ev.preventDefault();
      return;
    }
    if (mod === CTRL && code === 'KeyX') {
      // Ctrl + X
      this.copyActiveComp();
      this.designer.deleteActiveComp();
      ev.preventDefault();
      return;
    }
    if (mod === CTRL && code === 'KeyC') {
      // Ctrl + C
      this.copyActiveComp();
      ev.preventDefault();
      return;
    }
    if (mod === CTRL && code === 'KeyV') {
      // Ctrl + V
      this.pasteComponent();
      ev.preventDefault();
      return;
    }
    if (mod === CTRL && (code === 'Digit0' || code === 'Numpad0') && this.designer.zoom !== 100) {
      // Ctrl + 0 按两次 会先重置canvas缩放 然后重置chrome缩放
      this.designer.zoom = 100;
      ev.preventDefault();
      return;
    }
    if (mod === ALT) {
      // 按下alt后 启用inspect模式
      startInspector(ev, this.designer);
      return;
    }
  }
  pasteComponent() {
    readClipboard().then(async str => {
      const insertedCompPath = await pasteComponentToDesigner(str, this.designer);
      if (typeof insertedCompPath === 'string') this.designer.compPath = insertedCompPath;
    }).catch(err => {
      alert(`粘贴组件失败 请检查浏览器的剪贴板权限\n${err}`);
      console.error('粘贴组件失败', err);
    });
  }
  copyActiveComp() {
    return copyComponentToClipBoard(this.designer);
  }
}
export function startInspector(ev, designer) {
  if (designer.editZoneState.inspecting) return;
  designer.editZoneState.inspecting = true;
  const inspector = new CompInspector({
    parent: designer
  });
  const div = document.createElement('div');
  const canvasWrapper = designer.$el.querySelector('.ucd-editZone-canvasWrapper');
  canvasWrapper.appendChild(div);
  inspector.$mount(div);
  const destroy = () => {
    inspector.$destroy();
    inspector.$el.remove();
  };
  const onMove = ev => {
    if (ev.clientX) {
      designer.editZoneState.lastMousePos = {
        clientX: ev.clientX,
        clientY: ev.clientY
      };
    }
    inspector.onMouseMove(ev);
  };
  onMove(designer.editZoneState.lastMousePos);
  // @ts-ignore
  startMouseMove({
    initialEvent: ev,
    onMove,
    onEnd: () => {
      designer.editZoneState.inspecting = false;
      destroy();
    },
    trigger: [{
      event: 'keyup',
      eventFilter: ev => !ev.altKey,
      type: 'onEnd',
      options: true
    }, {
      event: 'keydown',
      eventFilter: ev => {
        designer.hoveringCompPath = '';
        const mouseEv = designer.editZoneState.lastMousePos;
        onMove({
          ...mouseEv,
          shiftKey: ev.shiftKey
        });
        return false;
      },
      type: 'onEnd',
      options: {
        capture: true,
        once: false
      }
    }, {
      event: 'keyup',
      eventFilter: ev => {
        const mouseEv = designer.editZoneState.lastMousePos;
        onMove({
          ...mouseEv,
          shiftKey: ev.shiftKey
        });
        return false;
      },
      type: 'onEnd',
      options: {
        capture: true,
        once: false
      }
    }]
  });
  ev.preventDefault();
}
//# sourceMappingURL=DesingerKeyPressEventHandler.js.map
